import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';
import _get from 'lodash/get';

import usePortalPlaceholder from '@sift/skipper/helpers/usePortalPlaceholder';
import PortalProvider from '@sift/skipper/components/PortalProvider';
import ToolbarPortal from './ToolbarPortal';

interface Props {
  children?: React.ReactNode;
  classes?: any;
}

function Page({ children: childrenProp, classes: classesFromProps }: Props) {
  const _classes = useStyles();
  const rootClassName = classnames(_get(_classes, 'root'), _get(classesFromProps, 'root'));
  const contentClassName = classnames(_get(_classes, 'content'), _get(classesFromProps, 'content'));
  const containerClassName = classnames(
    _get(_classes, 'container'),
    _get(classesFromProps, 'container'),
  );
  const ToolbarPlaceHolder = usePortalPlaceholder(ToolbarPortal);
  const children = React.Children.toArray(childrenProp);

  return (
    <PortalProvider>
      <div className={rootClassName}>
        <div className={contentClassName} data-cy="page-content">
          <div className={containerClassName}>{children}</div>
        </div>
        <ToolbarPlaceHolder />
      </div>
    </PortalProvider>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    width: '100%',
  },
  content: {
    padding: `${theme.spacing(4)}px ${theme.spacing(6)}px`,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflowY: 'auto',
  },
  container: {
    maxWidth: 1400,
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
  },
}));

export default Page;
